import * as CustomIcon from "@mui/icons-material";
import {
  DefaultFlexModifiers,
  DefaultSpacingModifiers,
  DefaultSizeModifiers,
  DefaultBackgroundModifier,
  DefaultPositionModifiers,
  DefaultRadiusModifiers,
} from "../Modifiers/index.js";
import { useResponsive } from "../Hooks/index.js";
import { color } from "../Theme/index.js";
import { brandKey } from "../../brand";
import { LUCIDE_ICONS } from "./lucideMap";

const IconProperties = ({ $onClick, $size, $pointer, ...rest }) => {
  return {
    style: {
      color: color(useResponsive(rest.$color)),
      fontSize: useResponsive($size),
      ...DefaultPositionModifiers(rest),
      ...DefaultSpacingModifiers(rest),
      ...DefaultFlexModifiers(rest),
      ...DefaultSizeModifiers(rest),
      ...DefaultBackgroundModifier(rest),
      ...DefaultRadiusModifiers(rest),
    },
    onClick: $onClick,
    cursor: $pointer,
  };
};

// Lucide icons size through width/height; MUI icons through font-size (1.5rem default).
// The MUI size keywords ($size="small" | "medium" | "large") are not valid SVG sizes: left as-is the SVG fills its container.
const LUCIDE_KEYWORD_SIZES = { small: 16, medium: 20, large: 24, inherit: "1em" };

const lucideSize = (fontSize) => {
  if (typeof fontSize === "string" && fontSize in LUCIDE_KEYWORD_SIZES) return LUCIDE_KEYWORD_SIZES[fontSize];
  if (typeof fontSize === "number") return fontSize;
  if (typeof fontSize === "string" && fontSize) return fontSize;
  return 20;
};

export default function Icon({ ...rest }) {
  const props = IconProperties(rest);
  // TLScare uses the Lucide set; GPS Care keeps the MUI icons it always had.
  const LucideIcon = brandKey === "tlscare" ? LUCIDE_ICONS[rest.$icon] : undefined;
  if (LucideIcon) {
    const { fontSize, ...style } = props.style;
    return (
      <LucideIcon
        aria-hidden="true"
        strokeWidth={1.75}
        size={lucideSize(fontSize)}
        style={style}
        onClick={props.onClick}
        cursor={props.cursor}
      />
    );
  }
  const FinalIcon = CustomIcon[rest.$icon];
  return <FinalIcon {...props} />;
}
